import {Component, HostBinding, Input} from '@angular/core';
import {Router} from '@angular/router';
import {LinkItem} from '@catui/types';

const componentBaseName = 'panel-list';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-panel-list',
  templateUrl: './panel-list.component.html',
  styleUrls: ['./panel-list.component.scss'],
})
export class PanelListComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() items: LinkItem[];
  @Input() title: string = null;
  @Input() noItemPlaceholder: string = null;

  constructor(private routerService: Router) {
  }

  onClick(item: LinkItem) {
    item.navigate(this.routerService);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/panel-list/panel-list.component.ts